import Api from '@common/plugins/Api/GaiaRepository';

class LanguageRepository {
  public get(data: FormData): Promise<LanguageInterface[]> {
    return Api.request('POST', 'language', data).then((response: DataObjectInterface) => response.data as unknown as LanguageInterface[]);
  }

  public change(language: LanguageInterface): Promise<void> {
    return Api.request('PATCH', 'language/change', language).then((response: DataObjectInterface) => response.data as unknown as void);
  }
}

export default new LanguageRepository();
